import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'Shared/Button';
import styles from './confirmation-panel.module.css';

interface ConfirmationPanelProps {
    confirm: () => void;
    cancel: () => void;
    children: React.ReactNode;
}

function ConfirmationPanel({
    children,
    confirm,
    cancel,
}: ConfirmationPanelProps): React.ReactElement<ConfirmationPanelProps> {
    const { t } = useTranslation(['buttons']);

    const confirmationHandler = () => {
        confirm();
    };

    const cancellationHandler = () => {
        cancel();
    };

    return (
        <div className={styles.ConfirmationPanel}>
            {children}
            <Button callback={confirmationHandler} text={t('buttons:confirm')} fullWidth withMarginBottom />
            <Button callback={cancellationHandler} text={t('buttons:cancel')} fullWidth inverse />
        </div>
    );
}

export default ConfirmationPanel;
